module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/seating_mobile-3fa427fd0b7d971a352fe4a2fbf39bc0.png";